module.exports = __webpack_public_path__ + "img/share-line.c4cb2154.svg";